import apiClient from "@/api/apiClient";
import { extractApiData } from "@/utils/apiResponseHandler";
import type { Model } from "@/types";
import type { AxiosRequestConfig } from "axios";

export class BaseAPI<T, CreateType = T> {
  model: string;

  constructor(model: Model) {
    this.model = `/${model}`;
  }

  async fetchAll(config?: AxiosRequestConfig): Promise<T[]> {
    return await apiClient.get(`${this.model}`, config).then(extractApiData);
  }

  async fetchById(id: number, config?: AxiosRequestConfig): Promise<T> {
    return await apiClient.get(`${this.model}/${id}`, config).then(extractApiData);
  }

  async update(id: number, data: CreateType, config?: AxiosRequestConfig): Promise<T> {
    return await apiClient
      .put(`${this.model}/${id}`, data, config)
      .then(extractApiData);
  }

  async create(data: CreateType | CreateType[], config?: AxiosRequestConfig): Promise<T | T[]> {
    return await apiClient.post(`${this.model}`, data, config).then(extractApiData);
  }

  delete(id: number, config?: AxiosRequestConfig): Promise<void> {
    return apiClient.delete(`${this.model}/${id}/`, config);
  }
}
